<section id="competences">
  <div class="container">
    <h2><strong>Tech Stack and Skills</strong></h2>
    <span class="bar-title mb-5"></span>
    <div class="row mt-2">
      <div
        class="col-lg-4"
        data-aos="fade-up "
        data-aos-anchor-placement="center-bottom"
        data-aos-delay="300"
      >
        <h5 class="h5"><strong>Technologies</strong></h5>
        <img
          src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/angularjs/angularjs-original.svg"
          width="60"
          height="60"
          style="vertical-align: middle; margin: 10px 5px"
        />
        <img
          src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/javascript/javascript-original.svg"
          width="60"
          height="60"
          style="vertical-align: middle; margin: 10px 5px"
        />
        <img
          src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/bootstrap/bootstrap-plain-wordmark.svg"
          width="60"
          height="60"
          style="vertical-align: middle; margin: 10px 5px"
        />
        <br />
        <img
          src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/css3/css3-plain-wordmark.svg"
          width="60"
          height="60"
          style="vertical-align: middle; margin: 10px 5px"
        />
        <img
          src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/cplusplus/cplusplus-plain.svg"
          width="60"
          height="60"
          style="vertical-align: middle; margin: 10px 5px"
        />
        <img
          src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/mysql/mysql-plain-wordmark.svg"
          width="75"
          height="75"
          style="vertical-align: middle; margin: 10px 5px"
        />
      </div>

      <div
        class="col-lg-4"
        data-aos="fade-down"
        data-aos-anchor-placement="center-bottom"
        data-aos-delay="300"
      >
        <h5 class="h5"><strong>Tools</strong></h5>
        <img
          src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/github/github-original-wordmark.svg"
          width="60"
          height="60"
          style="vertical-align: middle; margin: 10px 5px"
        />
        <img
          src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/firebase/firebase-plain-wordmark.svg"
          width="60"
          height="60"
          style="vertical-align: middle; margin: 10px 5px"
        />
        <img
          src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/npm/npm-original-wordmark.svg"
          width="75"
          height="75"
          style="vertical-align: middle; margin: 10px 5px"
        />
        <br />
        <img
          src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/heroku/heroku-original-wordmark.svg"
          width="60"
          height="60"
          style="vertical-align: middle; margin: 10px 5px"
        />
        <img
          src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/git/git-original-wordmark.svg"
          width="75"
          height="75"
          style="vertical-align: middle; margin: 10px 5px"
        />
        <br />
        <br />
        <br />
      </div>
    </div>
  </div>
</section>
